var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGreyRating = function SvgGreyRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E1E7",
    d: "M.5 0h24v24H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 5c.195 0 .374.108.46.277l1.886 3.72 4.216.6a.508.508 0 0 1 .413.336c.06.178.01.374-.128.506l-3.053 2.894.72 4.09a.487.487 0 0 1-.204.483.527.527 0 0 1-.54.036l-3.77-1.929-3.77 1.93a.527.527 0 0 1-.54-.037.487.487 0 0 1-.204-.484l.72-4.09-3.053-2.893a.483.483 0 0 1-.128-.506.508.508 0 0 1 .413-.337l4.216-.6 1.886-3.719A.514.514 0 0 1 12.5 5Z",
    fill: "#fff"
  })));
};
export default SvgGreyRating;